import styled from 'styled-components'
import {
  Divider as MuiDivider,
} from '@material-ui/core'

export const Divider = styled(MuiDivider)`
  margin: 10px 0px 10px 5px;
  background: white !important;
`